/* Clone LP runtime — SCS deal page picker/steps/ATC, static-data edition.
 * Source widget was a React app talking to SCS's fitment backend; this build
 * drives the SAME captured markup with a static fitment JSON + our variants.
 * Data tokens ({"source": "scsbiz.wearevisum.com/api/v1/years crawl 260721", "sample_years": ["2010", "2018", "2024"], "years": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"], "makes": ["Ford", "Ram", "Chevrolet", "GMC", "Dodge", "Toyota", "Acura", "Audi", "BMW", "BYD", "Buick", "Cadillac", "Chery", "Chrysler", "Genesis", "Honda", "Hyundai", "Infiniti", "Isuzu", "Jaguar", "Jeep", "Kia", "LDV", "Land Rover", "Lexus", "Lincoln", "Lucid", "MG", "Mahindra", "Maserati", "Mazda", "Mercedes", "Mini", "Mitsubishi", "Nissan", "Polestar", "Renault", "Ssangyong", "Subaru", "Suzuki", "Tesla", "Volkswagen", "Volvo"], "models": {"Ford": ["Bronco 2-Door", "Bronco 4-Door", "Bronco Raptor", "Bronco Sport", "C-Max", "Crown Victoria", "E Series", "E series", "E-Series Chassis", "EcoSport", "Edge", "Escape", "Everest", "Expedition", "Explorer", "F-150", "F-250", "F-350", "F-450", "F-550", "F-550 Chassis", "Fiesta", "Flex", "Focus", "Fusion", "Maverick", "Mondeo", "Mustang", "Ranger", "Shelby GT350", "Shelby GT500", "Taurus", "Transit"], "Ram": ["1500", "2500", "3500", "3500 Chassis", "4500 Chassis", "5500 Chassis", "Dakota", "ProMaster", "ProMaster Chassis", "ProMaster City"], "Chevrolet": ["Avalanche", "Aveo", "Blazer", "Blazer EV", "Bolt", "Camaro", "Caprice", "City Express", "Cobalt Sedan", "Colorado", "Corvette", "Cruze", "Equinox", "Equinox EV", "Express", "HHR", "Impala", "Malibu", "Silverado 1500", "Silverado 2500 HD", "Silverado 3500 HD", "Silverado 3500 HD Chassis", "Silverado EV", "Sonic", "Spark", "Suburban", "Tahoe", "Trailblazer", "Traverse", "Trax", "Volt"], "GMC": ["Acadia", "Canyon", "Hummer EV", "Sierra 1500", "Sierra 2500 HD", "Sierra 3500 HD", "Sierra EV", "Terrain", "Yukon"], "Dodge": ["Avenger", "Caliber", "Challenger", "Charger", "Dakota", "Durango", "Hornet", "Nitro", "ProMaster", "ProMaster Chassis", "ProMaster City", "Ram 1500", "Ram 2500", "Ram 3500", "Ram 3500 Chassis", "Ram 4500 Chassis", "Ram 5500 Chassis"], "Toyota": ["4Runner", "70 Series", "Avalon", "BZ4X", "C-HR", "Camry", "Corolla", "Corolla Cross", "Corolla Hatchback", "Corolla Hybrid", "Crown", "FJ Cruiser", "Fortuner", "GR", "GR86", "Grand Highlander", "Highlander", "Hilux", "Kluger", "Land Cruiser", "Matrix", "Mirai", "Prado", "Prius", "Prius Prime", "RAV4", "Sequoia", "Sequoia Capstone", "Sequoia Platinum", "Sequoia TRD", "Sienna", "Supra", "Tacoma", "Tarago", "Tundra", "Venza", "YARiS", "Yaris", "Yaris Cross"], "Acura": ["ILX", "Integra", "MDX", "NSX", "RDX", "RL", "RLX", "TL", "TLX", "TSX", "ZDX"], "Audi": ["A3", "A3 Cabriolet", "A4", "A4 Cabriolet", "A5", "A5 Sportback", "A6", "A6 Allroad", "A6 Cabriolet", "A6 Competition", "A7", "A8", "A8 W12", "E-Tron GT", "Q3", "Q4 E-Tron", "Q5", "Q7", "Q8", "Q8 E-Tron", "RS E-Tron GT", "RS Q8", "RS3", "RS5", "RS6", "RS7", "S3", "S3 Technik", "S4 Sedan", "S5", "S6", "S7", "S8", "SQ5", "SQ7", "SQ8", "SQ8 E-Tron", "TT", "TTS", "iTT", "iTTS"], "BMW": ["1 Series", "2 Series Convertible/Coupe", "2 Series Coupe", "3 Series", "300e Hybrid", "320i Sedan", "328 Wagon", "328d Sedan", "328i Convertible/Coupe", "328i Coupe", "328i Sedan", "328i Wagon", "328i xDrive Sedan", "328i xDrive Wagon", "328xi Coupe", "330e", "330i Sedan", "330i Wagon", "330i sedan", "335d Sedan", "335i Convertible/Coupe", "335i Sedan", "340i Sedan", "430i xDrive Coupe", "440i Coupe", "440i xDrive Coupe", "530e", "530i", "540d", "540i Sedan", "550i", "640i Gran Coupe", "7 Series", "740e xDrive", "740i", "750Li", "750i", "760Li", "8 Series", "94 AH", "Alpina B6", "Alpina B7", "M2", "M3", "M4", "M440i xDrive Coupe", "M550i", "M6", "M760i xDrive", "M8", "X1 28i", "X2 28i", "X2 xDrive28i", "X3 30i", "X3 M", "X3 M40i", "X4", "X4 M", "X4 M40i", "X5", "X5 M", "X5 M40i", "X5 M60i", "X6", "X6 M", "X6 M40i", "X6 M60i", "X6 xDrive 35i", "X7 40i", "X7 60i", "X7 Alpina XB7", "XM", "Z4 30i", "Z4 40i", "i4", "i4 eDrive35", "i5", "i7", "iX"], "BYD": ["Atto"], "Buick": ["Enclave", "Encore", "Envision", "Envista", "Evista", "La Crosse", "Lucerne", "Regal Sportback"], "Cadillac": ["ATS Coupe", "ATS Sedan", "CT4", "CT4-V Blackwing", "CT5", "CT6", "CTS Sedan", "DTS", "Escalade", "LYRIQ", "SRX", "STS", "XT4", "XT5", "XT6", "XTS"], "Chery": ["Omoda5"], "Chrysler": ["300", "PT Crusier", "Pacifica", "Sebring Convertible", "Sebring Coupe", "Sebring Sedan"], "Genesis": ["G70", "G80", "G90", "GV60", "GV70", "GV80"], "Honda": ["Accord", "CR-V", "Civic", "Civic  (All Except SI)", "Civic (All Except SI)", "Civic Hatchback", "Civic SI", "Civic Type R", "Clairity Hybrid", "Element", "Fit", "HR-V", "Insight", "Odyssey", "Passport", "Pilot", "Prologue", "Ridgeline", "Vezel"], "Hyundai": ["Accent", "Azera", "Elantra", "Elantra N Line", "Hatchback i30", "Ioniq", "Ioniq 5", "Ioniq 6", "Kona", "Kona Electric", "Kona N Line", "Palisade", "Santa Cruz", "Santa Fe", "Sonata", "Staria", "Tucson", "Venue", "Vera Cruz", "Wagon i30"], "Infiniti": ["EX35", "FX35", "G37 Convertible/Coupe", "G37 Sedan", "M35", "Q50", "Q60", "Q70", "QX30", "QX50", "QX55", "QX56", "QX60", "QX80"], "Isuzu": ["D-Max 2 Seater", "D-Max 5 Seater", "MU-X"], "Jaguar": ["E-PACE", "F-PACE", "F-Pace", "F-TYPE", "F-Type", "F-type", "I-PACE", "XE", "XF", "XJ", "XK"], "Jeep": ["Cherokee", "Commander", "Compass", "Gladiator", "Grand Cherokee", "Grand Cherokee L", "Grand Wagoneer", "Liberty", "Patriot", "Renegade", "Wrangler 2-Door", "Wrangler 4-Door"], "Kia": ["Cadenza", "Carnival", "Carnival LX, SX", "Cerato", "Cerato Coupe", "EV6", "EV9", "Forte", "Forte Koup", "Forte5", "K5", "Niro", "Optima", "Picanto", "Rio", "Seltos", "Sorento", "Soul", "Sportage", "Stinger", "Telluride"], "LDV": ["G10", "T60"], "Land Rover": ["Defender", "Discovery", "Range Rover", "Range Rover (All Other Trims)", "Range Rover Evoque", "Range Rover Evoque SE", "Range Rover Evoque SVR", "Range Rover LR4", "Range Rover SE Sport", "Range Rover Sport", "Range Rover Sport SE", "Range Rover Sport SV", "Range Rover Sport SVR", "Range Rover Velar"], "Lexus": ["ES", "GS", "GX", "HS", "IS", "IS Convertible", "LC", "LS", "LX", "NX", "RC", "RC, F", "RX", "RX Hybrid", "RZ", "SC", "TX"], "Lincoln": ["Aviator", "Corsair", "MKC", "MKS", "MKT", "MKX", "MKZ", "Nautilus", "Navigator"], "Lucid": ["Air Pure"], "MG": ["6 Plus", "GS", "HS +EV", "MG3", "MG4", "MG5", "ZS", "ZST"], "Mahindra": ["XUV700"], "Maserati": ["Ghibli", "GranTurismo", "Grecale", "Levante", "MC20", "Quattroporte"], "Mazda": ["BT-50", "CX-3", "CX-30", "CX-5", "CX-50", "CX-60", "CX-7", "CX-9", "CX-90", "MAZDA2", "MAZDA3", "MAZDA6", "MAZDASPEED3", "Mazda6", "Miata", "Tribute"], "Mercedes": ["AMG GT53", "AMG GT63", "C-Class AMG", "C-Class C300", "CL-Class", "CLA Class", "CLA-Class 250", "CLE", "CLS Class", "CLS Class AMG", "E-Class (All Except Convertible)", "EQE 350+", "EQE SUV", "EQS", "G Class", "GL Class", "GLA Class", "GLA-Class", "GLB Class", "GLB-Class", "GLC Class", "GLC-Class", "GLE Class", "GLE-Class", "GLK", "GLS Class", "GLS-Class", "M Class", "S-Class 450", "S-Class 550", "S-Class 560", "S-Class 580", "SL Class", "SLC Class", "SLK", "SLK Class", "Sprinter"], "Mini": ["Cooper", "Cooper Clubman", "Cooper Countryman", "Cooper Countryman Hybrid", "Countryman Classic Cooper"], "Mitsubishi": ["ASX", "Eclipse", "Eclipse Cross", "Galant", "Lancer", "Lancer Evolution", "Mirage", "Mirage G4", "Outlander", "Outlander Hybrid", "Outlander Sport", "Pajero Sport", "Triton"], "Nissan": ["370Z", "Altima Coupe", "Altima Sedan", "Ariya", "Armada", "Cube", "Frontier", "GT-R", "Kicks", "Leaf", "Maxima", "Murano", "Navara", "Pathfinder", "Patrol", "Qashqai", "Rogue", "Sentra", "Titan", "Versa", "X-Trail", "X-Trail 7 Seater", "Xterra", "Z"], "Polestar": ["2"], "Renault": ["Koleos"], "Ssangyong": ["Musso"], "Subaru": ["Ascent", "BRZ", "Crosstrek", "Forester", "Impreza", "Legacy", "Outback", "Solterra", "WRX", "XV"], "Suzuki": ["Jimny", "Swift", "Vitara"], "Tesla": ["Model 3", "Model S", "Model X", "Model Y"], "Volkswagen": ["Amarok", "Atlas", "Atlas Cross Sport", "Beetle", "CC", "Eos", "Golf", "Golf Alltrack", "Golf GTI", "Golf R Coupe", "Golf R Sedan", "Golf Sportwagen", "ID.4", "Jetta", "Jetta GLI", "Jetta Sportwagen", "Passat", "Routan", "T-Cross", "T-ROC", "Taos", "Tiguan", "Touareg", "e-Golf"], "Volvo": ["C30", "C40 Recharge", "C70", "S40", "S60", "S80", "S90", "V60", "V90", "XC40", "XC60", "XC70", "XC90"]}}) are injected by patch_scs_deal_template.py.
 * Vehicle rides along as a line-item property for fulfillment (variants only
 * encode Seats x Color; rear covers are universal-fit — the rear-config step
 * was dropped by owner ruling 260722).
 */
(function () {
  var F = {"source": "scsbiz.wearevisum.com/api/v1/years crawl 260721", "sample_years": ["2010", "2018", "2024"], "years": ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005", "2004", "2003", "2002", "2001", "2000", "1999"], "makes": ["Ford", "Ram", "Chevrolet", "GMC", "Dodge", "Toyota", "Acura", "Audi", "BMW", "BYD", "Buick", "Cadillac", "Chery", "Chrysler", "Genesis", "Honda", "Hyundai", "Infiniti", "Isuzu", "Jaguar", "Jeep", "Kia", "LDV", "Land Rover", "Lexus", "Lincoln", "Lucid", "MG", "Mahindra", "Maserati", "Mazda", "Mercedes", "Mini", "Mitsubishi", "Nissan", "Polestar", "Renault", "Ssangyong", "Subaru", "Suzuki", "Tesla", "Volkswagen", "Volvo"], "models": {"Ford": ["Bronco 2-Door", "Bronco 4-Door", "Bronco Raptor", "Bronco Sport", "C-Max", "Crown Victoria", "E Series", "E series", "E-Series Chassis", "EcoSport", "Edge", "Escape", "Everest", "Expedition", "Explorer", "F-150", "F-250", "F-350", "F-450", "F-550", "F-550 Chassis", "Fiesta", "Flex", "Focus", "Fusion", "Maverick", "Mondeo", "Mustang", "Ranger", "Shelby GT350", "Shelby GT500", "Taurus", "Transit"], "Ram": ["1500", "2500", "3500", "3500 Chassis", "4500 Chassis", "5500 Chassis", "Dakota", "ProMaster", "ProMaster Chassis", "ProMaster City"], "Chevrolet": ["Avalanche", "Aveo", "Blazer", "Blazer EV", "Bolt", "Camaro", "Caprice", "City Express", "Cobalt Sedan", "Colorado", "Corvette", "Cruze", "Equinox", "Equinox EV", "Express", "HHR", "Impala", "Malibu", "Silverado 1500", "Silverado 2500 HD", "Silverado 3500 HD", "Silverado 3500 HD Chassis", "Silverado EV", "Sonic", "Spark", "Suburban", "Tahoe", "Trailblazer", "Traverse", "Trax", "Volt"], "GMC": ["Acadia", "Canyon", "Hummer EV", "Sierra 1500", "Sierra 2500 HD", "Sierra 3500 HD", "Sierra EV", "Terrain", "Yukon"], "Dodge": ["Avenger", "Caliber", "Challenger", "Charger", "Dakota", "Durango", "Hornet", "Nitro", "ProMaster", "ProMaster Chassis", "ProMaster City", "Ram 1500", "Ram 2500", "Ram 3500", "Ram 3500 Chassis", "Ram 4500 Chassis", "Ram 5500 Chassis"], "Toyota": ["4Runner", "70 Series", "Avalon", "BZ4X", "C-HR", "Camry", "Corolla", "Corolla Cross", "Corolla Hatchback", "Corolla Hybrid", "Crown", "FJ Cruiser", "Fortuner", "GR", "GR86", "Grand Highlander", "Highlander", "Hilux", "Kluger", "Land Cruiser", "Matrix", "Mirai", "Prado", "Prius", "Prius Prime", "RAV4", "Sequoia", "Sequoia Capstone", "Sequoia Platinum", "Sequoia TRD", "Sienna", "Supra", "Tacoma", "Tarago", "Tundra", "Venza", "YARiS", "Yaris", "Yaris Cross"], "Acura": ["ILX", "Integra", "MDX", "NSX", "RDX", "RL", "RLX", "TL", "TLX", "TSX", "ZDX"], "Audi": ["A3", "A3 Cabriolet", "A4", "A4 Cabriolet", "A5", "A5 Sportback", "A6", "A6 Allroad", "A6 Cabriolet", "A6 Competition", "A7", "A8", "A8 W12", "E-Tron GT", "Q3", "Q4 E-Tron", "Q5", "Q7", "Q8", "Q8 E-Tron", "RS E-Tron GT", "RS Q8", "RS3", "RS5", "RS6", "RS7", "S3", "S3 Technik", "S4 Sedan", "S5", "S6", "S7", "S8", "SQ5", "SQ7", "SQ8", "SQ8 E-Tron", "TT", "TTS", "iTT", "iTTS"], "BMW": ["1 Series", "2 Series Convertible/Coupe", "2 Series Coupe", "3 Series", "300e Hybrid", "320i Sedan", "328 Wagon", "328d Sedan", "328i Convertible/Coupe", "328i Coupe", "328i Sedan", "328i Wagon", "328i xDrive Sedan", "328i xDrive Wagon", "328xi Coupe", "330e", "330i Sedan", "330i Wagon", "330i sedan", "335d Sedan", "335i Convertible/Coupe", "335i Sedan", "340i Sedan", "430i xDrive Coupe", "440i Coupe", "440i xDrive Coupe", "530e", "530i", "540d", "540i Sedan", "550i", "640i Gran Coupe", "7 Series", "740e xDrive", "740i", "750Li", "750i", "760Li", "8 Series", "94 AH", "Alpina B6", "Alpina B7", "M2", "M3", "M4", "M440i xDrive Coupe", "M550i", "M6", "M760i xDrive", "M8", "X1 28i", "X2 28i", "X2 xDrive28i", "X3 30i", "X3 M", "X3 M40i", "X4", "X4 M", "X4 M40i", "X5", "X5 M", "X5 M40i", "X5 M60i", "X6", "X6 M", "X6 M40i", "X6 M60i", "X6 xDrive 35i", "X7 40i", "X7 60i", "X7 Alpina XB7", "XM", "Z4 30i", "Z4 40i", "i4", "i4 eDrive35", "i5", "i7", "iX"], "BYD": ["Atto"], "Buick": ["Enclave", "Encore", "Envision", "Envista", "Evista", "La Crosse", "Lucerne", "Regal Sportback"], "Cadillac": ["ATS Coupe", "ATS Sedan", "CT4", "CT4-V Blackwing", "CT5", "CT6", "CTS Sedan", "DTS", "Escalade", "LYRIQ", "SRX", "STS", "XT4", "XT5", "XT6", "XTS"], "Chery": ["Omoda5"], "Chrysler": ["300", "PT Crusier", "Pacifica", "Sebring Convertible", "Sebring Coupe", "Sebring Sedan"], "Genesis": ["G70", "G80", "G90", "GV60", "GV70", "GV80"], "Honda": ["Accord", "CR-V", "Civic", "Civic  (All Except SI)", "Civic (All Except SI)", "Civic Hatchback", "Civic SI", "Civic Type R", "Clairity Hybrid", "Element", "Fit", "HR-V", "Insight", "Odyssey", "Passport", "Pilot", "Prologue", "Ridgeline", "Vezel"], "Hyundai": ["Accent", "Azera", "Elantra", "Elantra N Line", "Hatchback i30", "Ioniq", "Ioniq 5", "Ioniq 6", "Kona", "Kona Electric", "Kona N Line", "Palisade", "Santa Cruz", "Santa Fe", "Sonata", "Staria", "Tucson", "Venue", "Vera Cruz", "Wagon i30"], "Infiniti": ["EX35", "FX35", "G37 Convertible/Coupe", "G37 Sedan", "M35", "Q50", "Q60", "Q70", "QX30", "QX50", "QX55", "QX56", "QX60", "QX80"], "Isuzu": ["D-Max 2 Seater", "D-Max 5 Seater", "MU-X"], "Jaguar": ["E-PACE", "F-PACE", "F-Pace", "F-TYPE", "F-Type", "F-type", "I-PACE", "XE", "XF", "XJ", "XK"], "Jeep": ["Cherokee", "Commander", "Compass", "Gladiator", "Grand Cherokee", "Grand Cherokee L", "Grand Wagoneer", "Liberty", "Patriot", "Renegade", "Wrangler 2-Door", "Wrangler 4-Door"], "Kia": ["Cadenza", "Carnival", "Carnival LX, SX", "Cerato", "Cerato Coupe", "EV6", "EV9", "Forte", "Forte Koup", "Forte5", "K5", "Niro", "Optima", "Picanto", "Rio", "Seltos", "Sorento", "Soul", "Sportage", "Stinger", "Telluride"], "LDV": ["G10", "T60"], "Land Rover": ["Defender", "Discovery", "Range Rover", "Range Rover (All Other Trims)", "Range Rover Evoque", "Range Rover Evoque SE", "Range Rover Evoque SVR", "Range Rover LR4", "Range Rover SE Sport", "Range Rover Sport", "Range Rover Sport SE", "Range Rover Sport SV", "Range Rover Sport SVR", "Range Rover Velar"], "Lexus": ["ES", "GS", "GX", "HS", "IS", "IS Convertible", "LC", "LS", "LX", "NX", "RC", "RC, F", "RX", "RX Hybrid", "RZ", "SC", "TX"], "Lincoln": ["Aviator", "Corsair", "MKC", "MKS", "MKT", "MKX", "MKZ", "Nautilus", "Navigator"], "Lucid": ["Air Pure"], "MG": ["6 Plus", "GS", "HS +EV", "MG3", "MG4", "MG5", "ZS", "ZST"], "Mahindra": ["XUV700"], "Maserati": ["Ghibli", "GranTurismo", "Grecale", "Levante", "MC20", "Quattroporte"], "Mazda": ["BT-50", "CX-3", "CX-30", "CX-5", "CX-50", "CX-60", "CX-7", "CX-9", "CX-90", "MAZDA2", "MAZDA3", "MAZDA6", "MAZDASPEED3", "Mazda6", "Miata", "Tribute"], "Mercedes": ["AMG GT53", "AMG GT63", "C-Class AMG", "C-Class C300", "CL-Class", "CLA Class", "CLA-Class 250", "CLE", "CLS Class", "CLS Class AMG", "E-Class (All Except Convertible)", "EQE 350+", "EQE SUV", "EQS", "G Class", "GL Class", "GLA Class", "GLA-Class", "GLB Class", "GLB-Class", "GLC Class", "GLC-Class", "GLE Class", "GLE-Class", "GLK", "GLS Class", "GLS-Class", "M Class", "S-Class 450", "S-Class 550", "S-Class 560", "S-Class 580", "SL Class", "SLC Class", "SLK", "SLK Class", "Sprinter"], "Mini": ["Cooper", "Cooper Clubman", "Cooper Countryman", "Cooper Countryman Hybrid", "Countryman Classic Cooper"], "Mitsubishi": ["ASX", "Eclipse", "Eclipse Cross", "Galant", "Lancer", "Lancer Evolution", "Mirage", "Mirage G4", "Outlander", "Outlander Hybrid", "Outlander Sport", "Pajero Sport", "Triton"], "Nissan": ["370Z", "Altima Coupe", "Altima Sedan", "Ariya", "Armada", "Cube", "Frontier", "GT-R", "Kicks", "Leaf", "Maxima", "Murano", "Navara", "Pathfinder", "Patrol", "Qashqai", "Rogue", "Sentra", "Titan", "Versa", "X-Trail", "X-Trail 7 Seater", "Xterra", "Z"], "Polestar": ["2"], "Renault": ["Koleos"], "Ssangyong": ["Musso"], "Subaru": ["Ascent", "BRZ", "Crosstrek", "Forester", "Impreza", "Legacy", "Outback", "Solterra", "WRX", "XV"], "Suzuki": ["Jimny", "Swift", "Vitara"], "Tesla": ["Model 3", "Model S", "Model X", "Model Y"], "Volkswagen": ["Amarok", "Atlas", "Atlas Cross Sport", "Beetle", "CC", "Eos", "Golf", "Golf Alltrack", "Golf GTI", "Golf R Coupe", "Golf R Sedan", "Golf Sportwagen", "ID.4", "Jetta", "Jetta GLI", "Jetta Sportwagen", "Passat", "Routan", "T-Cross", "T-ROC", "Taos", "Tiguan", "Touareg", "e-Golf"], "Volvo": ["C30", "C40 Recharge", "C70", "S40", "S60", "S80", "S90", "V60", "V90", "XC40", "XC60", "XC70", "XC90"]}}; // {years:[], makes:[], models:{make:[...]}}
  var VS = window.__CLONE_VARIANTS || [];
  var state = { year: '', make: '', model: '', seats: '', color: 'Black' };
  // source groups the make dropdown (window.scs_use_optgroup); fitment makes[] is
  // already stored priority-first, so the first 6 ARE the source's Top Sellers
  var TOP_SELLERS = ['Ford', 'Ram', 'Chevrolet', 'GMC', 'Dodge', 'Toyota'];

  function steps() { return document.querySelectorAll('section[class*="_section__step"]'); }
  var LOCK = '_section_locked_1z0wa_140', ACTIVE = '_section_active_1z0wa_136';
  function setLock(ix, locked) {
    var s = steps()[ix]; if (!s) return;
    s.classList[locked ? 'add' : 'remove'](LOCK);
    s.classList[locked ? 'remove' : 'add'](ACTIVE);
  }

  /* ---- catalog entry ----
   * The cloned catalog products (/products/luxury-seat-covers-ford-f-150 ...)
   * are stub templates that bounce here carrying their vehicle, colour and
   * catalog item id. The picker still makes the buyer pick their model YEAR —
   * only that buyer knows it — so the make/model intent is replayed onto the
   * cascade the moment a year is chosen, and dropped as soon as the buyer
   * touches the make/model selects themselves. */
  var ENTRY = (function () {
    var q = new URLSearchParams(location.search);
    return { make: q.get('v_make') || '', model: q.get('v_model') || '',
             color: q.get('color') || '', cid: q.get('cid') || '' };
  })();

  /* ---- step 1: vehicle selects ---- */
  var ySel = document.getElementById('default-vehicle-year'),
      mkSel = document.getElementById('default-vehicle-make'),
      moSel = document.getElementById('default-vehicle-model');
  function fill(sel, opts, ph) {
    sel.innerHTML = '';
    var o0 = document.createElement('option');
    o0.value = ''; o0.textContent = ph; sel.appendChild(o0);
    function opt(parent, v) {
      var o = document.createElement('option'); o.value = v; o.textContent = v; parent.appendChild(o);
    }
    if (sel === mkSel) { // makes render grouped like source: Top Sellers / All Others
      var g1 = document.createElement('optgroup'); g1.label = 'Top Sellers';
      var g2 = document.createElement('optgroup'); g2.label = 'All Others';
      TOP_SELLERS.forEach(function (v) { if (opts.indexOf(v) >= 0) opt(g1, v); });
      opts.forEach(function (v) { if (TOP_SELLERS.indexOf(v) < 0) opt(g2, v); });
      sel.appendChild(g1); sel.appendChild(g2);
    } else {
      opts.forEach(function (v) { opt(sel, v); });
    }
    sel.disabled = false;
  }
  function applyEntryVehicle() {
    if (!ENTRY.make || !state.year || F.makes.indexOf(ENTRY.make) < 0) return;
    mkSel.value = ENTRY.make; state.make = ENTRY.make;
    var models = F.models[state.make] || [];
    fill(moSel, models, 'Model');
    if (ENTRY.model && models.indexOf(ENTRY.model) >= 0) {
      moSel.value = ENTRY.model; state.model = ENTRY.model;
    }
  }
  if (ySel && mkSel && moSel) {
    ySel.addEventListener('change', function () {
      state.year = ySel.value; state.make = state.model = '';
      fill(mkSel, F.makes, 'Make');
      moSel.innerHTML = '<option>Model</option>'; moSel.disabled = true;
      applyEntryVehicle();
      sync();
    });
    mkSel.addEventListener('change', function () {
      ENTRY.make = ENTRY.model = '';        /* buyer overrides the catalog intent */
      state.make = mkSel.value; state.model = '';
      fill(moSel, F.models[state.make] || [], 'Model');
      sync();
    });
    moSel.addEventListener('change', function () {
      ENTRY.model = '';
      state.model = moSel.value; sync();
    });
  }

  /* ---- step 2: seats cards ---- */
  document.addEventListener('change', function (e) {
    if (e.target.name === 'Seats[]') { state.seats = e.target.value; sync(); }
  });

  /* ---- step 3 + hero: color ---- */
  function paintColor() {
    document.querySelectorAll('input[name="Color"]').forEach(function (i) {
      i.checked = i.value === state.color;
      var box = i.closest('[class*="_color_option"]');
      if (box) box.classList[i.checked ? 'add' : 'remove']('_checked_nokqm_33');
    });
    var t = document.querySelector('#step_2 strong');
    if (t) t.innerHTML = t.innerHTML.replace(/Color(\s*-\s*[^<]*)?/, 'Color - ' + state.color);
  }
  document.addEventListener('change', function (e) {
    if (e.target.name === 'Color') { state.color = e.target.value; paintColor(); sync(); }
  });

  /* ---- resolve variant + sync UI ---- */
  function variant() {
    for (var i = 0; i < VS.length; i++) {
      if (VS[i].option1 === state.seats && VS[i].option2 === state.color) return VS[i];
    }
    return null;
  }
  function fmt(c) { return '$' + Math.round(c / 100); }
  function sync() {
    var hasVehicle = !!(state.year && state.make && state.model);
    /* source CSS dims + pointer-events:none the setup/color sections while the
       wrapper sits at [data-step="1"]; the source React app bumps this attr as
       the buyer advances — without the bump, REAL mouse clicks never land */
    var wrap = document.querySelector('[data-step]');
    if (wrap) wrap.setAttribute('data-step', hasVehicle ? '2' : '1');
    setLock(1, !hasVehicle);
    /* steps() index 2 = color (rear-config section removed) */
    setLock(2, !(hasVehicle && state.seats));
    /* headline personalization (source behavior) */
    if (hasVehicle) {
      var h = document.querySelector('h1');
      if (h) h.textContent = (state.year + ' ' + state.make + ' ' + state.model +
                              ' Luxury Seat Covers ' + state.color).toUpperCase();
    }
    /* ATC price + enable */
    var btn = document.querySelector('#step_nav button');
    if (!btn) return;
    var v = variant(), ready = hasVehicle && state.seats && v;
    btn.disabled = !ready;
    if (v) {
      var p = btn.querySelector('[data-testid="add-to-cart-price"]'),
          cp = btn.querySelector('[data-testid="add-to-cart-compare-price"]');
      if (p) p.textContent = fmt(v.price);
      /* compare = variant compare (or price) + $185 gift value — source math kept literal */
      if (cp) cp.textContent = fmt((v.compare_at_price || v.price) + 18500);
      window.__CLONE_VID = v.id;
      window.__CLONE_PROPS = {
        _Vehicle: state.year + ' ' + state.make + ' ' + state.model
      };
    }
  }

  /* ---- evergreen countdown (promo bar + deal timer digits) ---- */
  var KEY = 'scs_deal_deadline';
  var end = +localStorage.getItem(KEY) || 0;
  if (!end || end < Date.now()) { end = Date.now() + 24 * 3600e3; localStorage.setItem(KEY, end); }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = Math.max(0, end - Date.now()), s = Math.floor(left / 1000);
    var d = { days: Math.floor(s / 86400), hours: Math.floor(s % 86400 / 3600),
              mins: Math.floor(s % 3600 / 60), secs: s % 60 };
    [['scs-days', d.days], ['scs-hours', d.hours], ['scs-minutes', d.mins], ['scs-seconds', d.secs]]
      .forEach(function (p) {
        var el = document.getElementById(p[0]); if (el) el.textContent = two(p[1]);
      });
    document.querySelectorAll('countdown-timer [data-unit]').forEach(function (el) {
      var u = el.getAttribute('data-unit');
      if (d[u] != null) el.textContent = two(d[u]);
    });
  }
  setInterval(tick, 1000); tick();

  /* header cart icon: engine emit truncated the anchor's svg — restore a bag icon */
  var cartA = document.getElementById('cart-icon-bubble');
  if (cartA && !cartA.querySelector('svg')) {
    cartA.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
      '<path d="M6 7h12l1 14H5L6 7z"/><path d="M9 7a3 3 0 016 0"/></svg>' +
      '<span class="visually-hidden">Cart</span><span class="cart-link__bubble"></span>';
  }

  /* ---- videos: source theme JS (lazy loader + stamped widget + slick) is
     stripped, so nothing ever promotes data-src or opens the video modal ---- */
  document.querySelectorAll('video').forEach(function (v) {
    var changed = false;
    if (!v.getAttribute('src') && v.getAttribute('data-src')) {
      v.setAttribute('src', v.getAttribute('data-src')); changed = true;
    }
    v.querySelectorAll('source').forEach(function (s) {
      if (!s.getAttribute('src') && s.getAttribute('data-src')) {
        s.setAttribute('src', s.getAttribute('data-src')); changed = true;
      }
    });
    if (changed) {
      v.load();
      if (v.closest('.internal-video--playing') || v.autoplay) {
        v.muted = true;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    }
  });

  /* See It In Action: review thumbs carry data-video (mp4s already rehosted);
     wire them to the source's own <dialog id="modal_video"> player */
  var dlg = document.getElementById('modal_video');
  document.addEventListener('click', function (e) {
    var it = e.target.closest('.video_item');
    if (!it || !dlg) return;
    var url = it.getAttribute('data-video');
    if (!url) return;
    e.preventDefault();
    var v = dlg.querySelector('video');
    if (!v) return;
    var s = v.querySelector('source');
    if (s) s.setAttribute('src', url); else v.setAttribute('src', url);
    v.load();
    if (dlg.showModal && !dlg.open) dlg.showModal();
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  });
  if (dlg) dlg.addEventListener('close', function () {
    var v = dlg.querySelector('video'); if (v) v.pause();
  });

  /* addon upsells: slick clones the slides for its infinite loop, but the JS is
     stripped so the clones stay as static duplicates. Each clone carries the SAME
     checkbox id as its real card, so a real card's <label for="addon_..."> toggles
     the FIRST (hidden clone) match, not itself — hence "last product toggle won't
     turn on" (owner 260722). Drop the clones: ids go unique, labels bind right. */
  document.querySelectorAll('#step_upsells .slick-cloned').forEach(function (c) { c.remove(); });

  /* splide JS is stripped, so its .splide__arrows containers render empty —
     inject prev/next buttons (the click handler below drives the scrolling) */
  document.querySelectorAll('.splide__arrows').forEach(function (box) {
    if (box.querySelector('.splide__arrow')) return;
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'splide__arrow splide__arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous slide' : 'Next slide');
      b.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="24" height="24">' +
        '<path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4z"/></svg>';
      box.appendChild(b);
    });
  });

  /* carousels (addons slick + view-in-action splide) run on CSS scroll-snap
     now — arrows just scroll the container */
  document.addEventListener('click', function (e) {
    var ar = e.target.closest('.slick-arrow, .splide__arrow');
    if (ar) {
      // nearest slider first — a section can hold several (gallery main + thumbs)
      var box = ar.closest('.slick-slider, .splide') ||
                ar.closest('section, [id^="shopify-section"]');
      var sc = box && box.querySelector('.slick-list, .splide__track');
      if (!sc) return;
      e.preventDefault();
      var dir = /prev/i.test(ar.className) ? -1 : 1;
      /* smooth glide on arrow taps (owner 260722: upsell slider felt janky) —
         scroll-snap still lands cleanly on the next card */
      sc.scrollBy({ left: dir * sc.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }
    // thumb strip -> jump main gallery to the same slide
    var th = e.target.closest('[class*="_product_thumbs"] .slick-slide');
    if (!th || th.classList.contains('slick-cloned')) return;
    var real = [].filter.call(th.parentElement.children, function (x) {
      return !x.classList.contains('slick-cloned');
    });
    var ix = real.indexOf(th);
    var main = document.querySelector('[class*="_product_main_image"] .slick-list');
    if (ix >= 0 && main) main.scrollTo({ left: ix * main.clientWidth, behavior: 'auto' });
  });

  /* gallery: keep the red-bordered thumb (.slick-current) tracking whatever slide
     the main scroller shows — it was frozen on slide 0 (owner 260722 round-4) */
  (function () {
    var mainList = document.querySelector('[class*="_product_main_image"] .slick-list');
    var thumbWrap = document.querySelector('[class*="_product_thumbs"]');
    if (!mainList || !thumbWrap) return;
    var pending;
    mainList.addEventListener('scroll', function () {
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = 0;
        var ix = Math.round(mainList.scrollLeft / mainList.clientWidth);
        var thumbs = [].filter.call(thumbWrap.querySelectorAll('.slick-slide'),
          function (t) { return !t.classList.contains('slick-cloned'); });
        thumbs.forEach(function (t, i) { t.classList.toggle('slick-current', i === ix); });
        var cur = thumbs[ix], tl = thumbWrap.querySelector('.slick-list');
        if (cur && tl) {
          var cr = cur.getBoundingClientRect(), lr = tl.getBoundingClientRect();
          if (cr.top < lr.top || cr.bottom > lr.bottom || cr.left < lr.left || cr.right > lr.right)
            cur.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    }, { passive: true });
  })();

  /* sticky mobile Add-To-Cart: mirrors the buy-box CTA and, on tap, glides up to
     the real ATC button (owner 260722 round-4: no sticky CTA on mobile). Visible
     only while the real CTA is off-screen. */
  (function () {
    var atc = document.querySelector('#step_nav button');
    if (!atc) return;
    var st = document.createElement('style');
    st.textContent =
      '#scs-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:9997;padding:8px 12px;' +
      'background:#fff;box-shadow:0 -4px 16px rgba(0,0,0,.12);transform:translateY(120%);' +
      'transition:transform .25s ease}' +
      '#scs-sticky-atc.on{transform:none}' +
      '#scs-sticky-atc button{display:flex;align-items:center;justify-content:center;gap:8px;' +
      'width:100%;border:0;border-radius:10px;background:#e8271c;color:#fff;font-weight:800;' +
      'font-size:16px;text-transform:uppercase;letter-spacing:.4px;padding:14px;cursor:pointer}' +
      '#scs-sticky-atc button s{opacity:.7;font-weight:600}' +
      '@media(min-width:768px){#scs-sticky-atc{display:none!important}}';
    document.head.appendChild(st);
    var bar = document.createElement('div');
    bar.id = 'scs-sticky-atc';
    bar.innerHTML = '<button type="button"></button>';
    document.body.appendChild(bar);
    var sBtn = bar.querySelector('button');
    function mirror() { sBtn.innerHTML = atc.innerHTML; }
    mirror();
    new MutationObserver(mirror).observe(atc, { childList: true, subtree: true, characterData: true });
    sBtn.addEventListener('click', function () {
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    /* scroll-driven visibility (IntersectionObserver is flaky for off-screen
       nodes here): show the bar until the real CTA nears the viewport */
    var barRaf;
    function toggleBar() {
      var r = atc.getBoundingClientRect();
      bar.classList.toggle('on', r.top > window.innerHeight * 0.9 || r.bottom < 0);
    }
    toggleBar();
    window.addEventListener('scroll', function () {
      if (barRaf) return;
      barRaf = requestAnimationFrame(function () { barRaf = 0; toggleBar(); });
    }, { passive: true });
    window.addEventListener('resize', toggleBar);
  })();

  /* Meta ViewContent: this LP is a `page` template, so Shopify never emits
     product_viewed and the store pixel misses ViewContent (owner 260722). Fire
     it once, on the SAME pixel the store already loads (id read live from the
     Meta signals config so it follows whatever the store's custom pixel is set
     to). PageView + AddToCart are already covered by the Web Pixels Manager —
     we do NOT duplicate those. */
  (function () {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var cfg = document.querySelector('script[src*="connect.facebook.net/signals/config/"]');
      var pid = cfg && (cfg.src.match(/config\/(\d+)/) || [])[1];
      if (window.fbq && pid) {
        clearInterval(iv);
        try {
          window.fbq('init', pid);
          /* catalog arrivals report the item they came from, so catalog
             retargeting can match ViewContent back to the feed row */
          window.fbq('trackSingle', pid, 'ViewContent', {
            content_ids: [ENTRY.cid ? Number(ENTRY.cid) : 7961697026090],
            content_type: 'product_group',
            content_name: ENTRY.make
              ? ('Luxury Seat Covers for ' + ENTRY.make + ' ' + ENTRY.model)
              : 'Luxury Seat Covers',
            value: 279.00, currency: 'USD'
          });
          window.__scsVCFired = pid;                 /* verification marker */
        } catch (e) {}
      } else if (tries > 50) { clearInterval(iv); }  /* ~10s ceiling */
    }, 200);
  })();

  /* initial state: everything past vehicle locked, ATC disabled */
  setLock(1, true); setLock(2, true);
  var b0 = document.querySelector('#step_nav button'); if (b0) b0.disabled = true;
  if (ENTRY.color) {
    var known = document.querySelector('input[name="Color"][value="' + ENTRY.color + '"]');
    if (known) state.color = ENTRY.color;
  }
  paintColor();
  if (ENTRY.make) {   /* headline matches the ad before a year is even picked */
    var h0 = document.querySelector('h1');
    if (h0) h0.textContent = (ENTRY.make + ' ' + ENTRY.model + ' Luxury Seat Covers ' +
                              state.color).toUpperCase();
  }
})();

/* Royal Ride Deal cart drawer — SCS-style mini cart (owner feedback 260722).
 *
 * Concatenated after clone-scs-deal-runtime.js into the single runtime asset
 * by patch_scs_deal_template.py. Data tokens injected by the patch script:
 *   __GIFTS_CONFIG__  -> free-gifts-config.json (variant ids, msrp, images)
 *   __GIFT_ASSET_URLS__ -> {asset filename: cdn url} for gift thumbnails
 *
 * Behaviors:
 *  - window.__scsDrawerOpen(): fetch /cart.js, render, slide in.
 *  - ATC intercept in the wrapper template calls __scsDrawerOpenAfterAdd()
 *    instead of jumping straight to /checkout (supersedes the 260719
 *    straight-to-checkout ruling — owner asked for the SCS drawer 260722).
 *  - window.__cloneGiftIds(): color-matched steering wheel variant + the 3
 *    fixed gifts; consumed by the wrapper's ATC add call.
 *  - Non-gift lines get qty steppers + remove; gifts render locked at $0.00
 *    with struck MSRPs. Removing the last seat-cover line also removes all
 *    gift lines (BXGY would otherwise re-price them at full MSRP).
 */
(function () {
  'use strict';
  var CFG = window.__GIFTS_CONFIG__ || null;
  if (!CFG) return;
  var ASSETS = window.__GIFT_ASSET_URLS__ || {};

  var GIFT_IDS = {};
  Object.keys(CFG.steering_by_seat_color || {}).forEach(function (c) {
    GIFT_IDS[CFG.steering_by_seat_color[c]] = 'swheel';
  });
  Object.keys(CFG.fixed_gift_variants || {}).forEach(function (k) {
    GIFT_IDS[CFG.fixed_gift_variants[k]] = k;
  });
  var META = {};
  (CFG.display || []).forEach(function (d) { META[d.key] = d; });

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* header cart icon: reflect item count + turn the /cart link into a drawer
     opener (owner 260722: bag showed no status; clicking jumped to the page).
     Badge sits at the icon's top-right corner with a small inset so it never
     clips the viewport edge on mobile (owner 260722 round-4). */
  function syncBadge(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.style.position = 'relative';
    var b = icon.querySelector('.cart-link__bubble');
    if (!b) { b = document.createElement('span'); b.className = 'cart-link__bubble'; icon.appendChild(b); }
    if (count > 0) {
      b.textContent = count;
      b.setAttribute('style', 'position:absolute;top:-7px;right:-3px;min-width:17px;height:17px;' +
        'padding:0 4px;background:#e21b30;color:#fff;border-radius:9px;font-size:11px;font-weight:700;' +
        'display:flex;align-items:center;justify-content:center;line-height:1;box-sizing:border-box;pointer-events:none');
    } else {
      b.textContent = '';
      b.setAttribute('style', 'display:none');
    }
  }

  function seatColorFromVariant() {
    var vs = window.__CLONE_VARIANTS || [];
    var vid = window.__CLONE_VID;
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].id === vid) {
        /* injected variants carry option1 (package) / option2 (color) */
        return String(vs[i].option2 || vs[i].option1 || '').trim();
      }
    }
    return '';
  }

  window.__cloneGiftIds = function () {
    var ids = [];
    var color = seatColorFromVariant();
    var sw = (CFG.steering_by_seat_color || {})[color] || CFG.steering_default;
    if (sw) ids.push(sw);
    Object.keys(CFG.fixed_gift_variants || {}).forEach(function (k) {
      ids.push(CFG.fixed_gift_variants[k]);
    });
    return ids;
  };
  window.__CLONE_GIFTS = window.__cloneGiftIds();

  /* ---------- markup ---------- */
  var CSS =
    '#scs-cart-ov{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:99998;' +
    'opacity:0;pointer-events:none;transition:opacity .25s}' +
    '#scs-cart-ov.on{opacity:1;pointer-events:auto}' +
    '#scs-cart{position:fixed;top:0;right:0;height:100%;width:430px;max-width:94vw;' +
    'background:#fff;z-index:99999;transform:translateX(105%);transition:transform .28s ease;' +
    'display:flex;flex-direction:column;font-family:inherit;box-shadow:-8px 0 30px rgba(0,0,0,.18)}' +
    '#scs-cart.on{transform:none}' +
    '#scs-cart *{box-sizing:border-box}' +
    '.scs-cart-head{display:flex;align-items:center;justify-content:space-between;' +
    'padding:18px 20px;border-bottom:1px solid #eee}' +
    '.scs-cart-head h3{margin:0;font-size:22px;font-weight:800;letter-spacing:.5px;' +
    'text-transform:uppercase}' +
    '.scs-cart-x{background:none;border:0;font-size:26px;line-height:1;cursor:pointer;padding:4px}' +
    '.scs-cart-body{flex:1;overflow-y:auto;padding:14px 20px}' +
    '.scs-line{display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #f2f2f2}' +
    '.scs-line img{width:96px;height:96px;object-fit:cover;border-radius:8px;flex:0 0 auto}' +
    '.scs-line-info{flex:1;min-width:0}' +
    '.scs-line-title{font-weight:800;text-transform:uppercase;font-size:14px;margin:0 0 2px}' +
    '.scs-line-sub{font-size:12px;color:#555;margin:1px 0}' +
    '.scs-line-bottom{display:flex;align-items:center;justify-content:space-between;margin-top:8px}' +
    '.scs-qty{display:inline-flex;align-items:center;border:1px solid #ddd;border-radius:6px}' +
    '.scs-qty button{width:28px;height:28px;background:none;border:0;font-size:16px;cursor:pointer}' +
    '.scs-qty span{min-width:24px;text-align:center;font-size:14px;font-weight:600}' +
    '.scs-line-price{text-align:right;font-weight:800;color:#e21b30;font-size:15px}' +
    '.scs-line-price s{display:block;color:#999;font-weight:400;font-size:12px}' +
    '.scs-line-rm{background:none;border:0;cursor:pointer;color:#999;font-size:16px;' +
    'align-self:flex-start;padding:2px 0 0 4px}' +
    '.scs-gifts{border:1.5px solid #e21b30;border-radius:12px;padding:14px;margin:14px 0}' +
    '.scs-gifts h4{margin:0 0 12px;font-size:16px;font-weight:800;text-transform:uppercase}' +
    '.scs-gift-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px 10px}' +
    '.scs-gift{display:flex;gap:8px;align-items:flex-start}' +
    '.scs-gift-imgwrap{position:relative;flex:0 0 auto}' +
    '.scs-gift img{width:52px;height:52px;object-fit:contain;border:1px solid #eee;' +
    'border-radius:8px;background:#fff}' +
    '.scs-gift-badge{position:absolute;top:-6px;left:-6px;background:#e21b30;color:#fff;' +
    'font-size:11px;font-weight:700;width:18px;height:18px;border-radius:50%;' +
    'display:flex;align-items:center;justify-content:center}' +
    '.scs-gift-t{font-size:11px;font-weight:800;text-transform:uppercase;line-height:1.25;margin:0}' +
    '.scs-gift-p{font-size:12px;font-weight:800;margin:2px 0 0}' +
    '.scs-gift-p s{color:#999;font-weight:400;margin-left:4px}' +
    '.scs-cart-foot{border-top:1px solid #eee;padding:14px 20px 18px}' +
    '.scs-subtotal{display:flex;justify-content:space-between;align-items:baseline;' +
    'font-weight:800;font-size:15px;text-transform:uppercase;margin-bottom:12px}' +
    '.scs-subtotal .p{color:#e21b30;font-size:18px}' +
    '.scs-subtotal .p s{color:#999;font-weight:400;font-size:13px;margin-left:6px}' +
    '.scs-checkout{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;' +
    'background:#e8271c;color:#fff;border:0;border-radius:8px;padding:16px;font-size:16px;' +
    'font-weight:800;text-transform:uppercase;letter-spacing:.4px;cursor:pointer}' +
    '.scs-checkout:hover{background:#c81f16}' +
    '.scs-cart-empty{text-align:center;color:#666;padding:40px 10px;font-size:15px}' +
    '@media(max-width:480px){#scs-cart{width:100vw;max-width:100vw}}';

  function el(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    return d.firstChild;
  }

  var built = false;
  function build() {
    if (built) return;
    built = true;
    var st = document.createElement('style');
    st.id = 'scs-cart-css';
    st.textContent = CSS;
    document.head.appendChild(st);
    document.body.appendChild(el('<div id="scs-cart-ov"></div>'));
    document.body.appendChild(el(
      '<aside id="scs-cart" aria-label="Cart">' +
      '<div class="scs-cart-head"><h3>Your Cart</h3>' +
      '<button class="scs-cart-x" aria-label="Close">&times;</button></div>' +
      '<div class="scs-cart-body"></div>' +
      '<div class="scs-cart-foot"></div>' +
      '</aside>'));
    document.getElementById('scs-cart-ov').addEventListener('click', close);
    document.querySelector('#scs-cart .scs-cart-x').addEventListener('click', close);
  }

  function open() {
    build();
    /* slide in immediately, fetch+render async — waiting on /cart.js first made
       the panel appear only after the network round-trip (owner 260722: "not
       smooth"). Body keeps its last render until the fresh cart lands. */
    document.getElementById('scs-cart-ov').classList.add('on');
    document.getElementById('scs-cart').classList.add('on');
    document.body.style.overflow = 'hidden';
    refresh();
  }

  function close() {
    var ov = document.getElementById('scs-cart-ov');
    if (!ov) return;
    ov.classList.remove('on');
    document.getElementById('scs-cart').classList.remove('on');
    document.body.style.overflow = '';
  }

  function giftKey(item) { return GIFT_IDS[item.variant_id]; }

  function compareFor(item) {
    /* seat cover set: compare_at from the injected variants table */
    var vs = window.__CLONE_VARIANTS || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].id === item.variant_id && vs[i].compare_at_price) {
        return vs[i].compare_at_price * (item.quantity || 1);
      }
    }
    return null;
  }

  function render(cart) {
    var body = document.querySelector('#scs-cart .scs-cart-body');
    var foot = document.querySelector('#scs-cart .scs-cart-foot');
    var mains = [], gifts = [];
    (cart.items || []).forEach(function (it) {
      (giftKey(it) ? gifts : mains).push(it);
    });

    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="scs-cart-empty">Your cart is empty.</div>';
      foot.innerHTML = '';
      syncBadge(0);
      return;
    }

    var h = '';
    mains.forEach(function (it) {
      var props = it.properties || {};
      var sub = '';
      if (it.variant_title) sub += '<p class="scs-line-sub">' + esc(it.variant_title) + '</p>';
      if (props._Vehicle) sub += '<p class="scs-line-sub">Your Vehicle : ' + esc(props._Vehicle) + '</p>';
      var cmp = compareFor(it);
      h += '<div class="scs-line" data-key="' + esc(it.key) + '">' +
        '<img src="' + esc(it.image || '') + '" alt="">' +
        '<div class="scs-line-info">' +
        '<p class="scs-line-title">' + esc(it.product_title) + '</p>' + sub +
        '<div class="scs-line-bottom">' +
        '<span class="scs-qty"><button data-d="-1">&minus;</button><span>' + it.quantity +
        '</span><button data-d="1">+</button></span>' +
        '<span class="scs-line-price">' + money(it.final_line_price) +
        (cmp ? '<s>' + money(cmp) + '</s>' : '') + '</span>' +
        '</div></div>' +
        '<button class="scs-line-rm" title="Remove" data-key="' + esc(it.key) + '">&#128465;</button>' +
        '</div>';
    });

    if (mains.length) {
      h += '<div class="scs-gifts"><h4>Free Gifts &#127873;</h4><div class="scs-gift-grid">';
      (CFG.display || []).forEach(function (d) {
        var live = gifts.filter(function (g) { return giftKey(g) === d.key; })[0];
        var qty = live ? live.quantity : 1;
        var img = ASSETS[d.img_asset] || '';
        h += '<div class="scs-gift"><span class="scs-gift-imgwrap">' +
          '<span class="scs-gift-badge">' + qty + '</span>' +
          '<img src="' + esc(img) + '" alt=""></span>' +
          '<span><p class="scs-gift-t">' + esc(d.title) + '</p>' +
          '<p class="scs-gift-p">$0.00<s>$' + esc(d.msrp) + '</s></p></span></div>';
      });
      h += '</div></div>';
    }
    body.innerHTML = h;

    var count = (cart.items || []).reduce(function (a, b) { return a + b.quantity; }, 0);
    syncBadge(count);
    var cmpTotal = 0;
    mains.forEach(function (it) { cmpTotal += (compareFor(it) || it.final_line_price); });
    (CFG.display || []).forEach(function (d) {
      if (mains.length) cmpTotal += Math.round(parseFloat(d.msrp) * 100);
    });
    foot.innerHTML =
      '<div class="scs-subtotal"><span>Subtotal (' + count + ' items)</span>' +
      '<span class="p">' + money(cart.total_price) +
      (cmpTotal > cart.total_price ? '<s>' + money(cmpTotal) + '</s>' : '') + '</span></div>' +
      '<button class="scs-checkout">&#128274; Continue Checkout &rsaquo;</button>';

    foot.querySelector('.scs-checkout').addEventListener('click', function () {
      location.href = '/checkout';
    });
    body.querySelectorAll('.scs-qty button').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.closest('.scs-line');
        var it = mains.filter(function (m) { return m.key === line.getAttribute('data-key'); })[0];
        if (!it) return;
        changeQty(it, it.quantity + parseInt(b.getAttribute('data-d'), 10), mains);
      });
    });
    body.querySelectorAll('.scs-line-rm').forEach(function (b) {
      b.addEventListener('click', function () {
        var it = mains.filter(function (m) { return m.key === b.getAttribute('data-key'); })[0];
        if (it) changeQty(it, 0, mains);
      });
    });
  }

  function changeQty(item, qty, mains) {
    /* Each seat-cover set and its gifts share a _gid, so removing a set removes exactly the
       gifts it earned -- a leftover gift can no longer survive to eat a slot in the discount,
       which is what billed the $100 warranty on order #1004. Carts started before grouping
       shipped carry no _gid, so the old whole-cart sweep stays as their fallback. */
    var gid = (item.properties || {})._gid || null;
    var dropGroup = qty === 0 && !!gid && !giftKey(item);
    var lastMain = qty === 0 && !gid && mains.length === 1;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!dropGroup && !lastMain) return cart;
        var updates = {};
        (cart.items || []).forEach(function (it) {
          if (dropGroup) { if (((it.properties || {})._gid) === gid) updates[it.key] = 0; }
          else if (giftKey(it)) updates[it.key] = 0;
        });
        if (!Object.keys(updates).length) return cart;
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      })
      .then(function () { refresh(); })
      .catch(function () { refresh(); });
  }

  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); })
      .then(render).catch(function () {});
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  window.__scsDrawerOpen = open;
  window.__scsDrawerOpenAfterAdd = open;
  /* header cart icon path used by the chrome runtime */
  window.__cloneDrawerOpen = open;

  /* header bag: intercept the /cart link -> drawer, and paint the live count */
  function wireCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon || icon.__scsWired) return;
    icon.__scsWired = true;
    icon.addEventListener('click', function (e) { e.preventDefault(); open(); });
  }
  wireCartIcon();
  document.addEventListener('DOMContentLoaded', wireCartIcon);
  fetch('/cart.js').then(function (r) { return r.json(); })
    .then(function (c) { syncBadge(c.item_count || 0); }).catch(function () {});
})();
